import {
  ItemPageAdminSectionPluginModel,
  ItemPageAdminSectionDto,
} from '@marketplace-web/item-page/item-page-data'

export const getItemPageAdminSectionPluginModel = (
  pluginData: ItemPageAdminSectionDto,
): ItemPageAdminSectionPluginModel => ({
  itemId: pluginData.item_id,
})
